import type { OfferApi } from './types';

export function useOfferApi(): OfferApi {
  return {};
}
